export default [
  {
    fullName: 'НАДЕЖДА ПЛОТНИКОВА',
    jobTitle: 'Системный аналитик',
    description: 'Банковская группа Синара',
    photo: require('@/assets/speakers/356_3.png')
  },
  {
    fullName: 'ВЛАДИМИР БУРМИСТРОВ',
    jobTitle: 'Фулстак аналитик++',
    description: 'Холдинг Т1',
    photo: require('@/assets/speakers/356_1.png')
  },
  {
    fullName: 'ТАТЬЯНА ОШУРКОВА',
    jobTitle: 'Аналитик, Разработчик',
    description: 'Росбанк',
    photo: require('@/assets/speakers/356_5.png')
  },
  {
    fullName: 'НАДЕЖДА МАЗЕПА',
    jobTitle: 'Руководитель направления системной аналитики',
    description: 'МТС Банк',
    photo: require('@/assets/speakers/356_2.png')
  },
  {
    fullName: 'ПАША КОРШИКОВ',
    jobTitle: 'Ведущий',
    description: 'TechMeetup',
    photo: require('@/assets/speakers/356_4.png')
  }
]
